import React, { useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import ClearIcon from '@mui/icons-material/Clear'
import { Grid } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { useTheme } from '@mui/material/styles'
import OutlinedInput from '@mui/material/OutlinedInput'
import {
  AddPlantToUser,
  FetchInternalUsersListNew,
  FetchPlantListNew,
  DeleteUserNew,
} from '../../services/api'
import Deleteplantimg from '../../assets/images/delete1.svg'
import Button from '@mui/material/Button'
import dayjs from 'dayjs'

import useInternalUserlistStyles from './styles'

const InternalUserlist = () => {
  const classes = useInternalUserlistStyles()
  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
  }

  const thStyle = {
    backgroundColor: '#f2f2f2',
    padding: '8px',
    textAlign: 'center',
  }

  const tdStyle = {
    border: '1px solid #dddddd',
    padding: '8px',
    textAlign: 'center',
  }
  const theme = useTheme()
  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  }

  function getStyles(name, plantIds, theme) {
    return {
      fontWeight:
        plantIds.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    }
  }

  const [open, setOpen] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [email, setEmail] = React.useState('')
  const [deleteuserEmail, setDeleteuserEmail] = React.useState('')
  const [plantList, setPlantList] = React.useState([])
  const [usersList, setUsersList] = React.useState([])
  const [username, setUserName] = useState('')
  const [userId, setUserId] = useState('')
  const [deleteuserId, setDeleteUserId] = useState('')

  const [plantIds, setPlantIds] = React.useState([])
  const token = localStorage.getItem('accessToken')
  useEffect(() => {
    FetchInternalUsersListNew(token).then((resp) => {
      if (resp?.data) {
        setUsersList(resp?.data?.data)
        console.log("Internal users:", resp?.data?.data)
      } else {
      }
    })
    const Order = '1'
    FetchPlantListNew(dayjs().format('YYYY-MM-DD'), token, Order).then(
      (resp) => {
        if (resp?.data) {
          setPlantList(resp?.data?.data)
        } else {
        }
      }
    )
  }, [openDelete, open])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleDeleteOpen = () => {
    setOpenDelete(true)
  }

  const handleDeleteClose = () => {
    setOpenDelete(false)
  }

  const handleOpenDeleteUser = (Data) => {
    setDeleteUserId(Data?.userId)
    setDeleteuserEmail(Data?.email)
    handleDeleteOpen()
  }
  const handleDeleteUser = () => {
    DeleteUserNew(deleteuserId, token).then((resp) => {
      if (resp?.data) {
        handleDeleteClose()
      } else {
      }
    })
  }

  const handleAddplant = (Data) => {
    setUserId(Data?.id)
    setEmail(Data?.email)
    handleOpen()
  }

  const handleAddUser = () => {
    const Data = {
      userId: userId,
      plantIds: plantIds,
    }

    AddPlantToUser(Data, token).then((resp) => {
      if (resp?.data) {
        handleClose()
      } else {
      }
    })
  }

  const handleChangePlantName = (event) => {
    const {
      target: { value },
    } = event
    setPlantIds(typeof value === 'string' ? value.split(',') : value)
  }
  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Name</th>
              <th style={thStyle}>Email</th>
              <th style={thStyle}></th>
            </tr>
          </thead>
          <tbody>
            {usersList?.map((Data) => (
              <tr>
                <td style={tdStyle}>{Data?.name}</td>
                <td style={tdStyle}>{Data?.email}</td>
                <td style={tdStyle}>
                  <img
                    style={{
                      height: '20px',
                      width: '20px',
                      marginLeft: '30px',
                    }}
                    onClick={() => handleOpenDeleteUser(Data)}
                    src={Deleteplantimg}
                    alt="Addplant icon"
                  ></img>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Grid>

      <Dialog
        className="businessview_dialog"
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="align_btw brdr">
            <div className="h_1">Add Plant To User</div>

            <DialogActions>
              <ClearIcon onClick={handleClose} className="pointer" />
            </DialogActions>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ width: '100%' }}>
                <FormControl sx={{ m: 1, width: 300 }}>
                  <InputLabel id="demo-multiple-name-label">
                    Choose Plant
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    multiple
                    value={plantIds}
                    onChange={handleChangePlantName}
                    input={<OutlinedInput label="Choose Plant" />}
                    MenuProps={MenuProps}
                  >
                    {plantList?.map((name) => (
                      <MenuItem
                        key={name?.id}
                        value={name?.id}
                        style={getStyles(name, plantIds, theme)}
                      >
                        {name?.plantDetails?.plantName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div>{email}</div>
            </Grid>
          </Grid>

          <DialogActions>
            <button onClick={handleAddUser} className="save_btn">
              Save
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog
        className="Delete_dialog"
        open={openDelete}
        onClose={handleDeleteClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="align_btw brdr">
            <div className="h_1">
              {' '}
              Are you sure you want to delete this User?
            </div>

            <DialogActions>
              <ClearIcon onClick={handleDeleteClose} className="pointer" />
            </DialogActions>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                Email Id
              </div>
              <div>{deleteuserEmail}</div>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                User Id
              </div>
              <div>{deleteuserId}</div>
            </Grid>
          </Grid>

          <DialogActions>
            <Button onClick={handleDeleteClose}>Disagree</Button>
            <Button onClick={handleDeleteUser} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default InternalUserlist
